"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const TileGroupPagination_1 = require("../ui/TileGroupPagination");
const TileGroupLoadMoreButton_1 = require("../ui/TileGroupLoadMoreButton");
const TileGroupRedirectButton_1 = require("../ui/TileGroupRedirectButton");
const FacetedSearchApi_1 = require("src/search/facet/FacetedSearchApi");
var ControlsType;
(function (ControlsType) {
    ControlsType["RedirectButtn"] = "redirectButtn";
    ControlsType["ShowMoreButton"] = "showMoreButton";
    ControlsType["PaginationPanel"] = "paginationPanel";
    ControlsType["NoControl"] = "noControl";
})(ControlsType || (ControlsType = {}));
const SCROLL_HEADING_GUTTER_DESKTOP = 92;
const SCROLL_HEADING_GUTTER_MOBILE = 62;
const SCROLL_BOTTOM_GUTTER = 50;
const TileGroupControl = ({ labels: { loadMoreBtnLabel, loadLessBtnLabel, checkAllBtnLabel }, initialQueryParams, setWrapperState, tileGroupId, redirectUrl, totalCount, wrapperRef, isExpanded, paginationInfo, initialPageSize, service, }) => {
    const updateScrollHeadingGutter = () => {
        return (0, app_1.isMobile)() ? SCROLL_HEADING_GUTTER_MOBILE : SCROLL_HEADING_GUTTER_DESKTOP;
    };
    const [scrollHeadingGutter, setScrollHeadingGutter] = React.useState(updateScrollHeadingGutter());
    React.useEffect(() => {
        const setHeadingGutter = (0, app_1.throttle)(() => {
            setScrollHeadingGutter(updateScrollHeadingGutter());
        });
        window.addEventListener('resize', setHeadingGutter);
        return () => {
            window.removeEventListener('resize', setHeadingGutter);
        };
    }, []);
    const { currentPageIndex, tilesPerPage } = paginationInfo;
    const controlKeyToRender = React.useMemo(() => {
        let key = ControlsType.NoControl;
        const hasHiddenTiles = totalCount > initialPageSize;
        if (!!redirectUrl && hasHiddenTiles) {
            key = ControlsType.RedirectButtn;
        }
        else if (service.isPaginated) {
            key = ControlsType.PaginationPanel;
        }
        else if (hasHiddenTiles && !redirectUrl) {
            key = ControlsType.ShowMoreButton;
        }
        return key;
    }, [initialPageSize, redirectUrl, service.isPaginated, totalCount]);
    React.useLayoutEffect(() => {
        loadTilesByURLquery();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const pageQuantity = React.useMemo(() => Math.ceil(totalCount / tilesPerPage), [totalCount, tilesPerPage]);
    const validatPageInfoValues = React.useCallback((pageValue) => {
        const validatedPageInfo = pageValue;
        let shouldUpdateURLQueryParams = false;
        const pageQuantity = Math.ceil(totalCount / pageValue.tilesPerPage);
        if (pageValue.tilesPerPage <= 0 || pageQuantity <= 1) {
            validatedPageInfo.tilesPerPage = initialPageSize;
            validatedPageInfo.currentPageIndex = 0;
            shouldUpdateURLQueryParams = true;
        }
        if (pageValue.currentPageIndex < 0 || pageValue.currentPageIndex > totalCount) {
            validatedPageInfo.currentPageIndex = 0;
            shouldUpdateURLQueryParams = true;
        }
        if (shouldUpdateURLQueryParams) {
            const { currentPageIndex, tilesPerPage } = validatedPageInfo;
            app_1.UrlService.AddToUrl({
                key: tileGroupId,
                value: service.createURLKeyValueQueryParams(currentPageIndex, tilesPerPage),
            }, true);
        }
        return validatedPageInfo;
    }, [tilesPerPage, totalCount, pageQuantity]);
    const loadAdditionalTiles = React.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryParams = Object.assign(Object.assign({}, initialQueryParams), { offset: initialPageSize, pageSize: totalCount, sortOption: FacetedSearchApi_1.FacetSortOptionsEnum.AscendingSortByTitle });
        const data = yield service.fetchTiles(queryParams);
        setWrapperState(prev => (Object.assign(Object.assign({}, prev), { additionalTiles: data.items, statusInfo: data.statusInfo, isExpanded: true })));
        service.resetKTR();
    }), [initialQueryParams, initialPageSize, service, setWrapperState, totalCount]);
    const loadPaginatedTiles = React.useCallback((offset, tilesPerPage, currentPageIndex) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryParams = Object.assign(Object.assign({}, initialQueryParams), { offset, pageSize: tilesPerPage });
        const data = yield service.fetchTiles(queryParams);
        setWrapperState(prev => (Object.assign(Object.assign({}, prev), { tilesToShow: data.items, statusInfo: data.statusInfo, paginationInfo: {
                currentPageIndex,
                tilesPerPage,
            } })));
        service.resetKTR();
    }), [initialQueryParams, service, setWrapperState]);
    const loadTilesByURLquery = React.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const tileGroupUrlStringState = app_1.UrlService.GetQueryValueFromUrl(tileGroupId);
        if (!tileGroupUrlStringState) {
            return;
        }
        const tileGroupUrlObjectState = app_1.UrlService.GetQueryObjectValueFromUrl(tileGroupId);
        if (controlKeyToRender === ControlsType.ShowMoreButton &&
            tileGroupUrlStringState === 'expanded') {
            loadAdditionalTiles();
        }
        else if (controlKeyToRender === ControlsType.PaginationPanel &&
            tileGroupUrlObjectState.page) {
            const validatedPageInfo = validatPageInfoValues({ currentPageIndex, tilesPerPage });
            const offset = validatedPageInfo.currentPageIndex * validatedPageInfo.tilesPerPage;
            loadPaginatedTiles(offset, validatedPageInfo.tilesPerPage, validatedPageInfo.currentPageIndex);
        }
    }), [
        controlKeyToRender,
        currentPageIndex,
        loadAdditionalTiles,
        loadPaginatedTiles,
        pageQuantity,
        tileGroupId,
        tilesPerPage,
    ]);
    const onPageChange = React.useCallback((obj) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const selectedPageIndex = obj.selected;
        const offset = selectedPageIndex * tilesPerPage;
        loadPaginatedTiles(offset, tilesPerPage, selectedPageIndex);
        const queryParamsValue = service.createURLKeyValueQueryParams(selectedPageIndex + 1, tilesPerPage);
        app_1.UrlService.AddToUrl({
            key: tileGroupId,
            value: queryParamsValue,
        }, true);
        app_1.scrollService.GoToElement(wrapperRef.current, scrollHeadingGutter);
    }), [loadPaginatedTiles, tilesPerPage, service, tileGroupId, wrapperRef, scrollHeadingGutter]);
    const onPageSizeChange = React.useCallback((tilesPerPage) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        loadPaginatedTiles(0, tilesPerPage, 0);
        const queryParamsValue = service.createURLKeyValueQueryParams(1, tilesPerPage);
        app_1.UrlService.AddToUrl({
            key: tileGroupId,
            value: queryParamsValue,
        }, true);
        app_1.scrollService.GoToElement(wrapperRef.current, scrollHeadingGutter);
    }), [loadPaginatedTiles, service, tileGroupId, wrapperRef, scrollHeadingGutter]);
    const onLoadMoreButtonClick = React.useCallback((event) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (isExpanded) {
            setWrapperState(prev => (Object.assign(Object.assign({}, prev), { additionalTiles: [], isExpanded: false })));
            app_1.UrlService.RemoveFromUrl(tileGroupId);
            service.resetKTR();
            setTimeout(() => {
                app_1.scrollService.GoToBottomOfElement(wrapperRef.current, SCROLL_BOTTOM_GUTTER);
            }, 50); // to wait for re-rendering
        }
        else {
            loadAdditionalTiles();
            app_1.UrlService.AddToUrl({ key: tileGroupId, value: 'expanded' }, true);
        }
    }), [isExpanded, loadAdditionalTiles, service, setWrapperState, tileGroupId, wrapperRef]);
    const controls = {
        redirectButtn: ((0, jsx_runtime_1.jsx)(TileGroupRedirectButton_1.default, { redirectUrl: redirectUrl, checkAllBtnLabel: checkAllBtnLabel })),
        showMoreButton: ((0, jsx_runtime_1.jsx)(TileGroupLoadMoreButton_1.default, { isExpanded: isExpanded, labelMore: loadMoreBtnLabel, labelLess: loadLessBtnLabel, tileGroupId: tileGroupId, onLoadMoreButtonClick: onLoadMoreButtonClick })),
        paginationPanel: ((0, jsx_runtime_1.jsx)(TileGroupPagination_1.default, { paginationInfo: paginationInfo, initialPageSize: initialPageSize, onPageChange: onPageChange, onPageSizeChange: onPageSizeChange, service: service, tileGroupId: tileGroupId, pageQuantity: pageQuantity })),
        noControl: null,
    };
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: controls[controlKeyToRender] });
};
exports.default = TileGroupControl;
